import React, { useEffect, useState } from "react";
import {
  Button,
  CardText,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";

import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "../../../../service/api";
import { SweetAlert } from "../../../../components/Alerts";
import { useAuth } from "../../../../context/AuthContext";
import {
  AiOutlinePoweroff,
  AiOutlineEyeInvisible,
  AiFillBell,
  AiOutlineEye,
} from "react-icons/ai";
import { BiMailSend } from "react-icons/bi";
import { getUser } from "../../../../service/auth";
import { formatDate } from "../../../../utility/FormatDate";
import { formatCurrency } from "../../../../utility/FormatCurrency";

function Communication({ refreshKey, setRefreshKey, policies }) {
  const [modal, setModal] = useState(false);

  const user = getUser();

  // Toggle for Modal
  const toggle = () => setModal(!modal);

  const [loading, setIsLoading] = useState(false);

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [confirmed, setConfirmed] = useState("");
  const [cover, setCover] = useState("");
  const [premium, setPremium] = useState("");
  const [expected_date, setExpectedDate] = useState("");
  const [comment, setComment] = useState("");
  const [contact_method, setContactMethod] = useState("");
  const [policyInfo, setPolicyInfo] = useState([]);
  const handleSubmit = () => {
    try {
      const response = api.post(`contacted`, {
        policy_id: policyInfo.P_PolicyNo,
        policy_no: policyInfo.P_OtherPolicyNo,
        date,
        time,
        cover: policyInfo.P_OtherCode,
        grail_date: policyInfo.P_RenewalDate,
        premium: policyInfo.P_Premium,
        contact_method,
        expected_date,
        comment,
        confirmed,
        contacted_by: user.name,
      });

      setRefreshKey(refreshKey + 1);
      SweetAlert({
        title: "Actualizado Com Sucesso!",
        icon: "success",
      });
    } catch (error) {
      console.log(error);
      SweetAlert({
        title: "Ocorreu um erro interno ao tentar efectuar a operação",
        text: "Se o problema persistir contacte o suporte técnico.",
        icon: "warning",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const selectedPolicy = (selectedId) => {
    const filteredPolicy = policies.find(
      (item) => item.P_PolicyNo === Number(selectedId)
    );

    setPolicyInfo(filteredPolicy);
  };

  return (
    <div>
      <Button
        outline
        style={{ color: "#000", border: "1px solid #000" }}
        onClick={toggle}
        size="sm"
      >
        Add Communications
      </Button>

      <Modal isOpen={modal} toggle={toggle} style={{ width: "740px" }}>
        <ModalHeader>
          <h5
            className="fw-700"
            style={{ fontSize: "18px", textAlign: "center" }}
          >
            New communication{" "}
          </h5>
        </ModalHeader>

        <ModalBody>
          <Row style={{ marginTop: "6px", height: "57px" }}>
            {" "}
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Produto{" "}
                </Label>
                <Input
                  bsSize="sm"
                  disabled
                  type="select"
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  {" "}
                  Apolice{" "}
                </Label>
                <Input
                  bsSize="sm"
                  type="select"
                  onChange={(e) => {
                    selectedPolicy(e.target.value);
                  }}
                >
                    <option></option>
                  {policies?.map((item) => (
                    <option value={item.P_PolicyNo}>
                      {item.P_OtherPolicyNo}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row style={{ marginTop: "6px", height: "57px" }}>
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Expiry{" "}
                </Label>
                <Input
                  value={formatDate(policyInfo.P_RenewalDate)}
                  disabled
                  bsSize="sm"
                  type="date"
                />
              </FormGroup>
            </Col>
            <Col></Col>
          </Row>

          <Row style={{ marginTop: "6px", height: "57px" }}>
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Cobertura{" "}
                </Label>
                <Input
                  value={policyInfo.P_OtherCode}
                  disabled
                  bsSize="sm"
                  type="email"
                  onChange={(e) => {
                    setCover(e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Premio Anual{" "}
                </Label>
                <Input
                  value={policyInfo.P_Premium}
                  disabled
                  bsSize="sm"
                  type="number"
                  onChange={(e) => {
                    setPremium(e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row
            style={{
              backgroundColor: "#dee2e6",
              marginLeft: "0px",
              marginRight: "0px",
              padding: "5px",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          >
            <Col>Communication </Col>
          </Row>

          <Row style={{ marginTop: "16px" }}>
            {" "}
            <Col>
              <FormGroup>
                <Label for="memberprovider">Metodo de communicacao </Label>
                <Input
                  value={contact_method}
                  bsSize="sm"
                  type="select"
                  onChange={(e) => {
                    setContactMethod(e.target.value);
                  }}
                >
                  {" "}
                  <option></option>
                  <option>Email</option>
                  <option>SMS</option>
                  <option>Phone call</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Data
                </Label>
                <Input
                  bsSize="sm"
                  type="date"
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                />
              </FormGroup>
            </Col>

            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Hora
                </Label>
                <Input
                  value={time}
                  bsSize="sm"
                  type="text"
                  onChange={(e) => {
                    setTime(e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Renovacao confirmada?{" "}
                </Label>
                <Input
                  value={confirmed}
                  bsSize="sm"
                  type="select"
                  onChange={(e) => {
                    setConfirmed(e.target.value);
                  }}
                >
                  {" "}
                  <option></option>
                  <option value={2}>Sim</option>
                  <option value={1}>Nao</option>
                </Input>
              </FormGroup>
            </Col>

            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Data Pretendida de Renovacao{" "}
                </Label>
                <Input
                  value={expected_date}
                  bsSize="sm"
                  type="date"
                  onChange={(e) => {
                    setExpectedDate(e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row></Row>

          <Row>
            <Col>
              <FormGroup>
                <Label for="memberprovider" style={{ lineHeight: "0px" }}>
                  Comment{" "}
                </Label>
                <Input
                  value={comment}
                  bsSize="sm"
                  type="textarea"
                  onChange={(e) => {
                    setComment(e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={toggle}
            style={{
              backgroundColor: "#fff",
              color: "#747587",
              border: "none",
            }}
          >
            <span className="ms-1 me-1">Close </span>
          </Button>
          <Button
            onClick={() => {
              handleSubmit();
              toggle();
            }}
            color="primary"
            className="btn-sm rounded"
            bssize="sm"
            style={{ width: "134px", marginLeft: "20px" }}
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Communication;
